import { z } from 'zod'
import { optionalText, requiredNumber, requiredText } from '../../../lib/forms/rules'

/**
 * Uçuş Kaydı ekle/düzenle şeması.
 *
 * <p>Süre **saat + dakika** olarak girilir ve gönderimde tek sayıya (dakika) toplanır — veritabanı
 * tek bir sayı tutuyor ve birimi dakika olarak beyan edildi. İkisi birden sıfır olamaz: "0'dan büyük
 * olmalıdır" kuralı toplam üzerindedir, tek tek alanlar üzerinde değil (2 sa 0 dk geçerlidir).
 *
 * <p>Uçuş tarihinde **gelecek yasağı yoktur** — toplantı kaydından bilinçli farkı budur; analistin
 * alan listesi o kuralı yalnız toplantı tarihine yazıyor.
 */
export const flightRecordFormSchema = z
  .object({
    flightDate: requiredText(),
    // `requiredNumber()` (tip: number | null) kullanılır ki alan TEMİZLENDİĞİNDE (`InputNumber`
    // null gönderir) kullanıcı çevrilmiş "zorunlu" mesajını görsün — ham `z.number()` o durumda
    // İngilizce "expected number, received null" yazardı.
    hours: requiredNumber(),
    minutes: requiredNumber(),
    description: optionalText(500),
  })
  .superRefine((v, ctx) => {
    const hours = v.hours ?? 0
    const minutes = v.minutes ?? 0
    // Dakika alanı 0-59: 90 dakika yazan kullanıcı "1 sa 30 dk" demek istiyordur, ama sessizce
    // kabul edilirse ekranda gördüğü sayı ile kaydedilen süre ayrışırdı.
    if (minutes > 59) {
      ctx.addIssue({
        code: 'custom',
        path: ['minutes'],
        message: 'timePortfolio.errors.minutesRange',
      })
    }
    // "0'dan büyük olmalıdır" kuralı TOPLAM üzerindedir: 2 sa 0 dk geçerlidir.
    if (hours * 60 + minutes <= 0) {
      ctx.addIssue({
        code: 'custom',
        path: ['hours'],
        message: 'timePortfolio.errors.durationPositive',
      })
    }
  })

export type FlightRecordFormValues = z.infer<typeof flightRecordFormSchema>
